<mibi-box-layout>

<a class="mibi-title" [routerLink]="tab.link">
    <div class="mibi-title__text">
        {{ tab.name }}
    </div>
</a>

</mibi-box-layout>